import {Model} from "@vuex-orm/core";

export default class CompositionDiscount extends Model {

    static entity = 'compositionDiscounts';

    static primaryKey = ['product_detail_composition_id', 'product_discount_id'];

    static fields () {
        return {
            product_detail_composition_id: this.attr(null),
            product_discount_id: this.attr(null),
        }
    }
}
